import { useCallback, useState } from "react";

import { useGlobalContext } from "../Context/GlobalContext";

export const useDriverRemainingTime = (taskId) => {
  const { packkyApi } = useGlobalContext();

  const [remainingTime, setRemainingTime] = useState(null);
  const [totalTime, setTotalTime] = useState(null);
  const [acknowledgeTime, setAcknowledgeTime] = useState(null);
  const [driverStatus, setDriverStatus] = useState(null);

  // =====================================================
  // GET DRIVER REMAINING TIME
  // =====================================================

  const fetchRemainingTime = useCallback(async () => {
    if (!taskId) {
      setRemainingTime(null);
      setTotalTime(null);
      setAcknowledgeTime(null);
      setDriverStatus(null);

      return null;
    }

    try {
      const payload = {
        taskId: String(taskId),
      };

      const res = await packkyApi.post(
        "/api/DriverTracker/v1.0/getDriverRemainingTime",
        payload,
      );

      if (res?.data?.responseCode === "00") {
        const raw = res?.data?.data?.[0];

        if (!raw) {
          setRemainingTime(null);
          setTotalTime(null);
          setAcknowledgeTime(null);
          setDriverStatus(null);

          return res?.data;
        }

        const newRemainingTime =
          raw?.remaining_time != null ? Number(raw.remaining_time) : null;

        const newTotalTime =
          raw?.total_time != null ? Number(raw.total_time) : null;

        const newAckTime = raw?.acknowledge_time || null;

        const newDriverStatus = raw?.driver_status || null;

        setRemainingTime(newRemainingTime);
        setTotalTime(newTotalTime);
        setAcknowledgeTime(newAckTime);
        setDriverStatus(newDriverStatus);
      } else {
        console.warn(
          "GET DRIVER REMAINING TIME RESPONSE CODE:",
          res?.data?.responseCode,
        );
      }

      return res?.data;
    } catch (error) {
      console.error("GET DRIVER REMAINING TIME ERROR:", error);

      return null;
    }
  }, [taskId, packkyApi]);

  // =====================================================
  // RETURN
  // =====================================================

  return {
    remainingTime,
    totalTime,
    acknowledgeTime,
    driverStatus,
    fetchRemainingTime,
  };
};
